import { render, staticRenderFns } from "./ButtonCta.vue?vue&type=template&id=2ef1213a&scoped=true"
import script from "./ButtonCta.vue?vue&type=script&lang=js"
export * from "./ButtonCta.vue?vue&type=script&lang=js"
import style0 from "./ButtonCta.vue?vue&type=style&index=0&id=2ef1213a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1213a",
  null
  
)

export default component.exports